import { createStore, combineReducers, applyMiddleware } from 'redux'
import ReduxThunk from 'redux-thunk'
import CocktailsReducer from '../reducers/CocktailsReducer'
import PromotionsReducer from '../reducers/PromotionsReducer'
import PromotionsDetailsReducer from '../reducers/PromotionsDetailsReducer'
import ProductsReducer from '../reducers/ProductsReducer'
import ProductsPerPageReducer from '../reducers/ProductsPerPageReducer'
import OrderTemplateReducer from '../reducers/OrderTemplateReducer'
import CartReducer from '../reducers/CartReducer'
import BackOrderReducer from '../reducers/BackOrderReducer'
import PermanentBackOrderReducer from '../reducers/PermanentBackOrderReducer'
import ReportsReducer from '../reducers/ReportsReducer'
import OngoingDealReducer from '../reducers/OngoingDealReducer'
import ProductMaintenanceReducer from '../reducers/ProductMaintenanceReducer'
import DiscountsReducer from '../reducers/DiscountsReducer'
import PaymentsReducer from '../reducers/PaymentsReducer'
import InvoicesReducer from '../reducers/InvoicesReducer'
import OrdersReducer from '../reducers/OrdersReducer'
import Orders3PLReducer from '../reducers/Orders3PLReducer'
import Products3PLReducer from '../reducers/Products3PLReducer'
import ProductsSupplierReducer from '../reducers/ProductsSupplierReducer'
import PromotionsSupplierReducer from '../reducers/PromotionsSupplierReducer'
import CustomerManagementReducer from '../reducers/CustomerManagementReducer'
import UserReducer from '../reducers/UserReducer'
import CategoriesReducer from '../reducers/CategoriesReducer'
import SupplierReducer from '../reducers/SupplierReducer'
import SuperSupplierReducer from '../reducers/SuperSupplierReducer'
import isLoading from '../reducers/LoadingReducer'
import ThreePLReducer from '../reducers/ThreePLReducer'
import Cart3PLReducer from '../reducers/Cart3PLReducer'
import CartSupplierReducer from '../reducers/CartSupplierReducer'
import CheckoutReducer from '../reducers/CheckoutReducer'
import OrderReceiptReducer from '../reducers/OrderReceiptReducer'
import CreditCardsReducer from '../reducers/CreditCardsReducer'
import AddressReducer from '../reducers/AddressReducer'
import ProductGridModalReducer from '../reducers/ProductGridModalReducer'
import DealBuilderSupplierReducer from '../reducers/DealBuilderSupplierReducer'
import SaleQuoteReducer from '../reducers/SaleQuoteReducer'
import DealBuilderReducer from '../reducers/DealBuilderReducer'
import PdfStatementReducer from '../reducers/PdfStatementReducer'
import ThreePlStockOnHandReducer from '../3pl/reducer/ThreePlStockOnHandReducer'
import ThreePlCustomers from '../3pl/reducer/threePlCustomerReducer'
import ThreePlOrdersReducer from '../3pl/reducer/threePlOrderReducer'
import ThreePlProductMaintenanceReducer from '../3pl/reducer/threePlProductMaintenanceReducer'
import ThreePLDealBuilderSupplierReducer from '../3pl/reducer/threePlDealBuilderReducer'
import ThreePlCreditAccount from '../3pl/reducer/threePlCreditAccountReducer'
import MyAccountReducer from '../reducers/MyAccountReducer'
import ThreePlAtRiskStockReducer from '../3pl/reducer/threePlAtRiskStockReducer'
import ThreePLFreightCalculatorReducer from '../3pl/reducer/threePLFreightCalculatorReducer'
import PdfViewReducer from '../3pl/reducer/pdfViewReducer'

function logger({ getState }) {
  return (next) => (action) => {
    const returnValue = next(action)
    console.log(action, getState())
    return returnValue
  }
}
function rootReducer(state = {}, action) {
  // loading
  if (action.type !== 'TOGGLE_LOADING' && state && state.isLoading) {
    return state
  }
  return reducers(state, action)
}

const reducers = combineReducers({
  isLoading,
  cocktails: CocktailsReducer,
  promotions: PromotionsReducer,
  promotionsDetails: PromotionsDetailsReducer,
  products: ProductsReducer,
  productsPerPage: ProductsPerPageReducer,
  orderTemplate: OrderTemplateReducer,
  dealBuilder: DealBuilderReducer,
  cart: CartReducer,
  backorder: BackOrderReducer,
  permanentBackorder: PermanentBackOrderReducer,
  reports: ReportsReducer,
  productMaintenance: ProductMaintenanceReducer,
  ongoingDeal: OngoingDealReducer,
  discounts: DiscountsReducer,
  payments: PaymentsReducer,
  invoices: InvoicesReducer,
  orders: OrdersReducer,
  orders3pl: Orders3PLReducer,
  products3pl: Products3PLReducer,
  productsSupplier: ProductsSupplierReducer,
  promotionsSupplier: PromotionsSupplierReducer,
  dealBuilderSupplier: DealBuilderSupplierReducer,
  cart3pl: Cart3PLReducer,
  cartSupplier: CartSupplierReducer,
  customerManagement: CustomerManagementReducer,
  user: UserReducer,
  categories: CategoriesReducer,
  supplier: SupplierReducer,
  superSupplier: SuperSupplierReducer,
  threePL: ThreePLReducer,
  checkout: CheckoutReducer,
  orderReceipt: OrderReceiptReducer,
  creditCards: CreditCardsReducer,
  addresses: AddressReducer,
  productGridModal: ProductGridModalReducer,
  saleQuote: SaleQuoteReducer,
  pdfStatement: PdfStatementReducer,
  threePlStockOnHand: ThreePlStockOnHandReducer,
  threePlCustomers: ThreePlCustomers,
  threePlOrders: ThreePlOrdersReducer,
  threePlProductMaintenanceReducer: ThreePlProductMaintenanceReducer,
  threePlDealBuilder: ThreePLDealBuilderSupplierReducer,
  threePlCreditAccount: ThreePlCreditAccount,
  myAccount: MyAccountReducer,
  threePlAtRiskStock: ThreePlAtRiskStockReducer,
  threePlFreightCalculator: ThreePLFreightCalculatorReducer,
  pdfViewModal: PdfViewReducer,
})

// store
export let store = createStore(rootReducer, applyMiddleware(ReduxThunk, logger))

export default store
